module.exports = __webpack_public_path__ + "img/back-eau.4666161c.jpg";